<template>
    <div class="titleBar" :class="{t_b : border}">
        <i @click="back"></i>
        <template v-if="title">
            {{title}}
        </template>
        <p v-else>
            <span v-for="(k, i) in tabs_arr" :class="{'cur' : tab_cur == k}" @click="tab_event(k)">{{i}}</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "titleBar",
        props: ['border','title','tabs','tabs_arr','callback'],
        data (){
            return {
                tab_cur : '' 
            }
        },
        watch : {
            tabs(newName, oldName) {
              this.tab_cur = newName
            }
        },
        methods: {
            back : function() {
                if(this.callback){
                    return this.$emit('callback')
                }
                window.location = 'hybird://method/exit'
            },
            tab_event : function(tab) {
                this.tab_cur = tab
                this.$emit('tab_click',tab)
            }
        },
        created: function () {
            let self = this
            self.tab_cur = this.tabs
        }
    }
</script>

<style lang="scss" scoped>
    .titleBar {
        position: fixed;
        top: 0;
        top: constant(safe-area-inset-top);
        top: env(safe-area-inset-top);
        left: 0;
        width: 100%;
        height: .88rem;
        text-align: center;
        line-height: .88rem;
        font-family: PingFangSC-Medium;
        font-size: .36rem;
        background-color: #fff;
        // border-bottom: 1px solid #eee;
        z-index: 99;
        &:before{
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: constant(safe-area-inset-top);
            height: env(safe-area-inset-top);
            background-color: #fff;
            z-index: 9998;
        }
        i{
            display: block;
            width: .44rem;
            height: .44rem;
            position: absolute;
            left: .4rem;
            top: 50%;
            transform: translateY(-50%);
            background: url("https://appd.knowbox.cn/ss/images/activity/nav_icon_black.png") 0 0/cover no-repeat;
            z-index: 99;
        }
        p{
            display: flex;
            padding: 0 .7rem;
            span{
                position: relative;
                display: inline-block;
                flex: 1;
                font-family: PingFangSC-Medium;
                font-size: .36rem;
                color: #8487a0;
                text-align: center;
            }
            .cur{
                color: #56586a;
                &:after{
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: .08rem;
                    margin: auto;
                    display: inline-block;
                    content: "";
                    width: .6rem;
                    height: .08rem;
                    background-color: #e7be84;
                    border-radius: 4px;
                    text-align: center;
                }
            }
        }
    }
    .t_b{
        border-bottom: 1px solid #eee;
    }

    /*iPhone X XS 2436x1125px at 458ppi */
    // @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    //     .titleBar{
    //         top: constant(safe-area-inset-top);
    //         top: env(safe-area-inset-top);
    //     }
    // }

    // /*iPhone XR 1792x828px at 326ppi */
    // @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    //     .titleBar{
    //         top: constant(safe-area-inset-top);
    //         top: env(safe-area-inset-top);
    //     }
    // }

    // /* iPhone XS Max 2688x1242px at 458ppi */
    // @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    //     .titleBar{
    //         top: constant(safe-area-inset-top);
    //         top: env(safe-area-inset-top);
    //     }
    // }

</style>